<template>
    <button
        :class="[$style['mds-button-group__item'], classObject]"
        :disabled="disabled"
        type="button"
        @click="makeActive"
    >
        <mds-icon
            v-if="icon"
            :class="[$style['mds-button-group__item-icon'], $style['mds-button-group__item-icon--left']]"
            :name="icon"
            :size="iconSize"
        ></mds-icon>
        {{ text }}
        <mds-icon
            v-if="iconRight"
            :class="[$style['mds-button-group__item-icon'], $style['mds-button-group__item-icon--right']]"
            :name="iconRight"
            :size="iconSize"
        ></mds-icon>
    </button>
</template>

<script>
    import MdsButtonGroupItemProps from './button-group-item_props.js';
    import MdsIcon from '@mds/icon';

    export default {
        name: 'MdsButtonGroupItem',
        components: {
            MdsIcon,
        },
        inject: ['parentVariation'],
        props: MdsButtonGroupItemProps,
        computed: {
            classObject() {
                const obj = {};
                obj[this.$style['mds-button-group__item-active']] = this.active;
                return obj;
            },
            iconSize() {
                return this.parentVariation.size === 'small' || this.parentVariation.size === 'medium'
                    ? 'small'
                    : 'medium';
            },
        },
        methods: {
            makeActive(event) {
                this.$emit('mds-button-group-item-active', event);
            },
        },
        mounted() {
            this.size = this.parentVariation.size;
        },
    };
</script>

<style lang="scss" module>
    @import './button-group.scss';
</style>
